export const getCurrentSection = (sections) => sections.find((section) => !section.completed) || sections[sections.length - 1];

export const getSectionsTotalTime = (sections) => sections.reduce((partialTime, section) => partialTime + section.time, 0);

export const getSectionCompletionTime = (section) =>
    Math.round((new Date(section.modificationTime).getTime() - new Date(section.startTime).getTime()) / 1000);

export const currentSectionIsLast = (sections) =>
    sections.findIndex((section) => !section.completed) === sections.length - 1 || sections.every((section) => section.completed);
